import React from 'react';
import { Tabs } from '@spark';

const TabNavigation = ({ activeTab, setActiveTab, tabs = ['entities', 'relations'] }) => {
    const formatTabName = (tab) => {
        return tab.charAt(0).toUpperCase() + tab.slice(1);
    };

    const tabItems = tabs.map((tab) => ({
        id: tab,
        label: formatTabName(tab),
    }));

    return (
        <div style={{ width: '100%', marginBottom: 24 }}>
            <Tabs
                items={tabItems}
                activeId={activeTab}
                onChange={setActiveTab}
                size="large"
                fill
            />
        </div>
    );
};

export default TabNavigation;
